import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { API } from '../constant';
import { useAuthContext } from "../context/AuthContext";
import { useState, useEffect } from 'react';
import Loading from "../Components/Hooks/Loading";
import { getToken } from '../helpers';

const AddPaymentMethodForm = () => {
const stripe = useStripe();
const elements = useElements();
const { user, setUser } = useAuthContext();
const userId = user?.id;
const [message, setMessage] = useState();
const [loading, setLoading] = useState(false);

const fUser = async()=>{
    if (!userId) return;
    setLoading(true);
    try{
    const response = await fetch(`${API}/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // set the auth token to the user's jwt
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (!response.ok) {
      const responseData = await response.json();
      throw new Error(responseData?.error?.message || responseData?.message || 'Failed to fetch user');
    }
    const newUser = await response.json()
    setUser(newUser);
    setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } 
  }
  useEffect(() => {
  fUser();
  },[userId])

const handleSubmit = async (event) => {
    
    event.preventDefault();

    if (!stripe || !elements) {
    return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
    });
   
    if (error) {
        setMessage(`Error: ${error.message}`);
    } else {
        setLoading(true);
        try {
            const response = await fetch(`${API}/stripe/add-payment-method`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify({
                    card: paymentMethod.card,
                    customerId: user.customerId,
                    paymentMethodId: paymentMethod.id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Payment method added successfully');
            } else {
                setMessage(`Error: ${data?.error?.message || 'Failed to add payment method'}`);
            }
        } catch (err) {
            setMessage('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    }
};

return (
    <form onSubmit={handleSubmit}>
        <CardElement />
        <div className="form-footer">
        <button className="theme-btn"type="submit" disabled={!stripe}>Add Payment Method</button>
        {loading && <Loading />}

        </div>
        <div className="message success">{message}</div>
        
    </form>
    );
};
export default AddPaymentMethodForm;
